//components
import {DayOfWeekMultiSelectComponent} from '../components/DomainData/DayOfWeekMultiSelect.component';
import {EquipmentClassMultiSelectComponent} from '../components/DomainData/EquipmentClassMultiSelect.component';
import {ProductSizeMultiSelectComponent} from '../components/DomainData/ProductSizeMultiSelect.component';
import {CustomersAutoCompleteComponent} from '../components/Customers/CustomersAutoComplete.component';
import {RequestCustomerGridComponent} from '../components/Grids/RequestCustomerGrid.component';
import {CompletionDetailsComponent} from '../components/ControlGroups/CompletionDetails.component';
import {RequestInvoiceNumbersComponent} from '../components/ControlGroups/RequestInvoiceNumbers.component';
import {GeneralDetailsComponent} from '../components/ControlGroups/GeneralDetails.component';
import {UserInfoComponent} from '../components/ControlGroups/UserInfo.component';
import {PaymentOptionMultiSelectComponent} from '../components';

import * as ent from '../entities/index'
import * as enums from '../enums/index'
import * as serv from '../services/index'
import * as filters from '../filters/index'


export class RequestUtil  {
    constructor(private customerService: serv.CustomerService) 
    { 
        
    }

    public static IsCustomerRequest(request: ent.Request){
        return (request.RequestTypeID == enums.RequestTypeEnum.Driver ||
                request.RequestTypeID == enums.RequestTypeEnum.SoldToCustomer ||
                request.RequestTypeID == enums.RequestTypeEnum.Payer ||
                request.RequestTypeID == enums.RequestTypeEnum.MaintainCustomer ||
                request.RequestTypeID == enums.RequestTypeEnum.FullServiceCustomer ||
                request.RequestTypeID == enums.RequestTypeEnum.EquipmentOnlyCustomer);
    }
  
    public static LoadRequestDays(request: ent.Request, dayOfWeekMS: DayOfWeekMultiSelectComponent, dayTypeID: enums.DayType): ent.RequestDay[]{
        var requestDays: ent.RequestDay[] = [];

        if (request.RequestDays){
            if (request.RequestDays.length > 0){
                for (var rd of request.RequestDays){
                    requestDays.push(rd);
                }
            }
        }

        for (var selectedID of dayOfWeekMS.selectedIDs){
            var requestDay: ent.RequestDay = {DayOfWeekID: selectedID, DayTypeID: dayTypeID};
            requestDays.push(requestDay);
        }
        
        return requestDays;
    }

    public static LoadRequestEquipmentClasses(request: ent.Request, ecMS: EquipmentClassMultiSelectComponent): ent.RequestEquipmentClass[]{
        var requestECs: ent.RequestEquipmentClass[] = [];

        if (request.RequestEquipmentClasses){
            if (request.RequestEquipmentClasses.length > 0){
                for (var rEC of request.RequestEquipmentClasses){
                    requestECs.push(rEC);
                }
            }
        }

        for (var selectedID of ecMS.selectedIDs){
            var rEC: ent.RequestEquipmentClass = {EquipmentClassID: selectedID};
            requestECs.push(rEC);
        }
        
        return requestECs;
    }

    public static LoadRequestEquipmentClassesFromEquipmentLineItems(lineItems: ent.EquipmentLineItem[]): ent.RequestEquipmentClass[]{
        var requestECs: ent.RequestEquipmentClass[] = [];

        for (var lineItem of lineItems){
            var r = requestECs.filter(x=>x.EquipmentClassID == lineItem.EquipmentClassID);
            if (r.length == 0){
                requestECs.push({EquipmentClassID: lineItem.EquipmentClassID});
            }
        }
        
        return requestECs;
    }

    public static LoadRequestEquipmentClassesFromRequestInstalls(request: ent.Request): ent.RequestEquipmentClass[]{
        var requestECs: ent.RequestEquipmentClass[] = [];

        if (request.VendorLineItems && request.VendorLineItems.length > 0) {
            requestECs.push({EquipmentClassID: enums.EquipmentClassEnum.Vendor});
        }
        
        if (request.CoolerLineItems && request.CoolerLineItems.length > 0) {
            requestECs.push({EquipmentClassID: enums.EquipmentClassEnum.Cooler});
        }

        if (request.FountainLineItems) {
            if (request.FountainLineItems.filter(x=>x.ModelGroup.NonSerialized == true).length > 0){
                requestECs.push({EquipmentClassID: enums.EquipmentClassEnum.FountainBarGun});
            }
            if (request.FountainLineItems.filter(x=>x.ModelGroup.NonSerialized == false).length > 0){
                requestECs.push({EquipmentClassID: enums.EquipmentClassEnum.Fountain});
            }
        }

        return requestECs;
    }

    public static LoadRequestProductSizes(request: ent.Request, productSizeMS: ProductSizeMultiSelectComponent): ent.RequestProductSize[]{
        var requestProductSizes: ent.RequestProductSize[] = [];

        if (request.RequestProductSizes){
            if (request.RequestProductSizes.length > 0){
                for (var rps of request.RequestProductSizes){
                    requestProductSizes.push(rps);
                }
            }
        }

        for (var selectedID of productSizeMS.selectedIDs){
            var requestProductSize: ent.RequestProductSize = {ProductSizeID: selectedID};
            requestProductSizes.push(requestProductSize);
        }
        
        return requestProductSizes;
    }

    public static LoadRequestPaymentOptions(request: ent.Request, paymentOptionMS: PaymentOptionMultiSelectComponent): ent.RequestPaymentOption[]{
        var requestPaymentOptions: ent.RequestPaymentOption[] = [];

        if (request.RequestPaymentOptions){
            if (request.RequestPaymentOptions.length > 0){
                for (var rpo of request.RequestPaymentOptions){
                    requestPaymentOptions.push(rpo);
                }
            }
        }

        for (var selectedID of paymentOptionMS.selectedIDs){
            var requestPaymentOption: ent.RequestPaymentOption = {PaymentOptionID: selectedID};
            requestPaymentOptions.push(requestPaymentOption);
        }
        
        return requestPaymentOptions;
    }

    public static GetSalesOfficeID(userInfoComponent: UserInfoComponent, generalDetailsComponent: GeneralDetailsComponent) : number {

        if (generalDetailsComponent && generalDetailsComponent.selectedCustomer && generalDetailsComponent.selectedCustomer.SalesOfficeID) {
            return generalDetailsComponent.selectedCustomer.SalesOfficeID;
        }
        else {
            return userInfoComponent.userInfo.SalesOffice.ID;
        }
    }

    public static LoadRequestCustomers(request: ent.Request, customersAC: CustomersAutoCompleteComponent, requestCustomerTypeID: enums.RequestCustomerTypeEnum): ent.RequestCustomer[]{
        var requestCustomers: ent.RequestCustomer[] = [];

        if (request.RequestCustomers){
            if (request.RequestCustomers.length > 0){
                for (var rc of request.RequestCustomers){
                    requestCustomers.push(rc);
                }
            }
        }

        for (var selectedID of customersAC.selectedCustomerNumbers){
            var requestCustomer: ent.RequestCustomer = {CustomerNumber: selectedID, RequestCustomerTypeID: requestCustomerTypeID};
            requestCustomers.push(requestCustomer);
        }
        
        return requestCustomers;
    }

    public static LoadRequestCustomersFromGrid(request: ent.Request, requestCustomersGrid: RequestCustomerGridComponent, requestCustomerTypeID: enums.RequestCustomerTypeEnum): ent.RequestCustomer[]{
        var requestCustomers: ent.RequestCustomer[] = [];

        if (request.RequestCustomers){
            if (request.RequestCustomers.length > 0){
                for (var rc of request.RequestCustomers){
                    requestCustomers.push(rc);
                }
            }
        }

        if (requestCustomersGrid && requestCustomersGrid.lineItems){
            for (var lineItem of requestCustomersGrid.lineItems){
                var requestCustomer: ent.RequestCustomer = {CustomerNumber: lineItem.CustomerNumber, RequestCustomerTypeID: requestCustomerTypeID};
                requestCustomers.push(requestCustomer);
            }
        }
        
        return requestCustomers;
    }

    public static LoadCompletionDetails(request: ent.Request, completionDetailsComponent: CompletionDetailsComponent){
        request.RequestCompletionNumbers = [];
        if (completionDetailsComponent != undefined){
            if (completionDetailsComponent.showSingle){
                if (completionDetailsComponent.completionNumber){
                    request.RequestCompletionNumbers.push({RequestID: request.ID, Number: completionDetailsComponent.completionNumber})
                }
            }
            else if (completionDetailsComponent.showMultiple){
                for (var item of completionDetailsComponent.lineItems){
                    if (item.Number && item.CompletionNumberLabelID > 0){
                        request.RequestCompletionNumbers.push({RequestID: request.ID, Number: item.Number, 
                            CompletionNumberLabelID: item.CompletionNumberLabelID, 
                            EquipmentLineItemIdentifier: item.EquipmentLineItemIdentifier, 
                            PartnerType: item.PartnerType,
                            MoreInfo: item.MoreInfo
                        })
                    }
                }
            }
            
        }
        
    }

    public static LoadRequestInvoiceNumbers(request: ent.Request, requestInvoiceNumbersComponent: RequestInvoiceNumbersComponent){
        request.RequestInvoiceNumbers = [];
        for (var item of requestInvoiceNumbersComponent.lineItems){
            if (item.Number){
                request.RequestInvoiceNumbers.push({RequestID: request.ID, Number: item.Number})
            }
        }
        
    }


    public static LoadSerialNumbers(request: ent.Request, generalDetailsComponent: GeneralDetailsComponent){
        request.RequestCompletionNumbers = [];
        if (generalDetailsComponent != undefined){
            if (generalDetailsComponent.includeOwnershipChangeChange){
                request.GeneralInfo.SerialNumbers = [];
                for (var item of generalDetailsComponent.serialNumbers){
                    if (item.SerialNumber){
                        request.GeneralInfo.SerialNumbers.push(item.SerialNumber)
                    }
                }
            }
            
        }
        
    }

    public static getBrowserName(): string {
        const agent = window.navigator.userAgent.toLowerCase()
        switch (true) {
          case agent.indexOf('edge') > -1:
            return 'Edge';
          case agent.indexOf('opr') > -1 && !!(<any>window).opr:
            return 'Opera';
          case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
            return 'Chrome';
          case agent.indexOf('trident') > -1:
            return 'Internet Explorer';
          case agent.indexOf('firefox') > -1:
            return 'Firefox';
          case agent.indexOf('safari') > -1:
            return 'Safari';
          default:
            return 'Other';
        }
    }

    public populateCustomerAutoComplete(ac: CustomersAutoCompleteComponent, customerNumber: string) {
        if (ac) {
            ac.customers = [];
            ac.selectedCustomerNumbers = [];

            var filter: filters.CustomerFilter = { CustomerNumber: customerNumber };
            this.customerService.getCustomers(filter).subscribe(x => {
                if (x && x.length > 0) {
                    var cust = x[0];
                    ac.customersModel = { name: cust.FullName, ID: cust.CustomerNumber };
                }

            });
        }
    }
}

